/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../../firebaseConfig";
import { toast } from "react-hot-toast";
import { UserAuth } from "../../context/authContext";
import { ec as EC } from "elliptic";
import { FaRegClipboard } from "react-icons/fa";
import { serverTimestamp } from "firebase/firestore";
import { FiHome, FiBox, FiArrowRight } from "react-icons/fi";

const HackMemPool = () => {
  const [roomId, setRoomId] = useState(localStorage.getItem("roomId") || "");
  const [team, setTeam] = useState(localStorage.getItem("team") || "");
  const { userData } = UserAuth();
  const [hasAddedTransactions, setHasAddedTransactions] = useState(false);
  const [transactions, setTransactions] = useState([]);

  const transactionCollection = team === "red" ? "redTeamTransactions" : "blueTeamTransactions";

  const generatePublicKeyFromPrivate = (privateKey) => {
    const ec = new EC("secp256k1");
    const keyPair = ec.keyFromPrivate(privateKey.slice(2), "hex");
    return "0x" + keyPair.getPublic(false, "hex").slice(2);
  };

  const verifyPrivateKey = (senderPrivateKey, senderPublicKey) => {
    const generatedSenderPublicKey = generatePublicKeyFromPrivate(senderPrivateKey);
    return generatedSenderPublicKey === senderPublicKey;
  };

  const verifyTransaction = async (transaction) => {
    if (!roomId) return;

    try {
      const signature = transaction.signature;
      const matchResult = signature.match(/0x[a-fA-F0-9]{64}/g);
      const [receiverPublicKey, senderPrivateKey] = matchResult;

      const senderPublicKey = prompt(
        "Enter the sender's public key to verify the transaction, in order to verify the transaction signature using RSA.(Senders public key is required to verify the transaction signature)"
      );
      if (!senderPublicKey) {
        toast.error("Sender's public key is required to verify the transaction");
        return;
      }

      const isValidPrivateKey = verifyPrivateKey(senderPrivateKey, senderPublicKey);

      if (!isValidPrivateKey) {
        toast.error("Invalid sender's publick key");
        return;
      } else {
        const res = await db
          .collection("rooms")
          .doc(roomId)
          .collection(transactionCollection)
          .doc(transaction.id)
          .update({
            minerPublicKey: userData.publicKey,
            status: "Validate",
            verified: true,
          });
        toast.success("Sender's private key verified successfully");
      }
      fetchRoomTransactions();
    } catch (e) {
      console.error("Failed to vote:", e.message);
      toast.error("Failed to vote");
    }
  };

  const validateTransaction = async (transaction) => {
    if (!roomId) return;

    const senderRef = db.collection("users").doc(transaction.senderEmail);
    const userSnapshot = await senderRef.get();
    const senderData = userSnapshot.data();
    if (!senderData) {
      toast.error("Sender not found");
      return;
    }

    if (userData.publicKey !== transaction.minerPublicKey) {
      toast.error("You are not the verifier of this transaction");
      return;
    }

    try {
      if (senderData.balance < transaction.amount) {
        toast.error("Insufficient balance");
        const res = await db
          .collection("rooms")
          .doc(roomId)
          .collection(transactionCollection)
          .doc(transaction.id)
          .update({
            status: "failed",
            failedMessage: "Insufficient balance",
            validatedAt: serverTimestamp(),
          });
      } else {
        const res = await db
          .collection("rooms")
          .doc(roomId)
          .collection(transactionCollection)
          .doc(transaction.id)
          .update({
            status: "Add to block",
            validatedAt: serverTimestamp(),
          });
        const newBalance = senderData.balance - transaction.amount;
        await senderRef.update({
          balance: newBalance,
        });
        toast.success("Validation successful!");
      }
    } catch (e) {
      console.error("Failed to vote:", e.message);
      toast.error("Failed to vote");
    }
  };

  const addTransactionToBlock = async (transaction) => {
    if (!roomId) return;
    if (!transaction.verified) {
      toast.error("Transaction not verified");
      return;
    }

    if (transaction.status === "Validate") {
      toast.error("Transaction is pending, first verify and validate the transaction");
      return;
    }

    if (transaction.status === "failed") {
      toast.error("Transaction is failed, cannot be added");
      return;
    }

    if (transaction.blockStatus === "added") {
      toast.error("Transaction already added to block");
      return;
    }

    if (transaction.minerPublicKey !== userData.publicKey) {
      toast.error("You are not the verifier of this transaction");
      return;
    }

    try {
      const res = await db
        .collection("rooms")
        .doc(roomId)
        .collection(transactionCollection)
        .doc(transaction.id)
        .update({
          blockStatus: "added",
          status: "Added to block",
          addedAt: serverTimestamp(),
        });
      toast.success("Transaction added to block successfully");
    } catch (e) {
      console.error("Failed to add transaction to block:", e.message);
      toast.error("Failed to add transaction to block");
    }
  };

  const updateActionState = (transaction) => {
    switch (transaction.status) {
      case "Verify":
        verifyTransaction(transaction);
        break;
      case "Validate":
        validateTransaction(transaction);
        break;
      case "Add to block":
        addTransactionToBlock(transaction);
        break;
    }
    fetchRoomTransactions();
  };

  const fetchRoomTransactions = async () => {
    if (!roomId || !transactionCollection) return;

    try {
      const roomRef = db.collection("rooms").doc(roomId);
      const unsubscribe = roomRef.collection(transactionCollection).onSnapshot((snapshot) => {
        const data = [];
        snapshot.forEach((t) => {
          data.push({ id: t.id, ...t.data() });
        });

        // Local sort to ensure consistent display without server index
        data.sort((a, b) => {
          const timeA = a.addedAt?.toMillis() || a.timestamp?.toMillis() || 0;
          const timeB = b.addedAt?.toMillis() || b.timestamp?.toMillis() || 0;
          return timeB - timeA;
        });

        setTransactions(data);
        const allAdded = data.every(
          (t) => t.status === "Added to block" || t.status === "Added to chain"
        );
        setHasAddedTransactions(allAdded);
      });
      return () => unsubscribe();
    } catch (error) {
      console.error("Error fetching room transactions:", error);
      toast.error("Error fetching room transactions.");
    }
  };

  useEffect(() => {
    if (roomId) fetchRoomTransactions();
  }, [roomId]);

  const copyToClipboard = (e, data) => {
    e.preventDefault();

    navigator.clipboard.writeText(data).then(
      () => {
        toast.success("Copied Successfully");
      },
      () => {
        toast.error("Failed to copy");
      }
    );
  };

  const isRedTeam = team === "red";
  const teamColor = isRedTeam ? "from-red-500 to-red-600" : "from-blue-500 to-blue-600";
  const teamAccent = isRedTeam ? "text-red-400" : "text-blue-400";
  const teamBorder = isRedTeam ? "border-red-500/30" : "border-blue-500/30";

  const pendingTransactions = transactions.filter(
    (transaction) =>
      transaction.status !== "genisis" &&
      transaction.status !== "Added to chain" &&
      transaction.status !== "Added to block"
  );

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="w-full">
        {/* Header */}
        <div className={`glass-card p-6 mb-6 border ${teamBorder}`}>
          <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center gap-3">
            <span
              className={`px-3 py-1 rounded-lg bg-gradient-to-r ${teamColor} text-white text-sm font-medium`}
            >
              {isRedTeam ? "Red Team" : "Blue Team"}
            </span>
            MemPool
            <span className="text-text-muted font-normal text-lg">Room: {roomId}</span>
          </h2>
        </div>

        {/* Transactions Table */}
        {pendingTransactions.length > 0 ? (
          <div className={`glass-card p-6 overflow-x-auto border ${teamBorder}`}>
            <table className="w-full">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="py-4 px-3 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                    Transaction Hash
                  </th>
                  <th className="py-4 px-3 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                    Sender
                  </th>
                  <th className="py-4 px-3 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                    Receiver
                  </th>
                  <th className="py-4 px-3 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                    Signature
                  </th>
                  <th className="py-4 px-3 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                    Timestamp
                  </th>
                  <th className="py-4 px-3 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                    Amount
                  </th>
                  <th className="py-4 px-3 text-left text-text-muted text-sm font-medium uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {pendingTransactions.map((transaction) => (
                  <tr
                    key={transaction.id}
                    className="border-b border-white/5 hover:bg-white/5 transition-colors"
                  >
                    <td className="py-4 px-3">
                      <div className="flex items-center gap-2">
                        <code className="text-white bg-white/10 px-2 py-1 rounded text-xs truncate max-w-[120px]">
                          {transaction.hash}
                        </code>
                        <button
                          onClick={(e) => copyToClipboard(e, transaction.hash)}
                          className="p-2 text-text-muted hover:text-primary transition-colors"
                        >
                          <FaRegClipboard />
                        </button>
                      </div>
                    </td>
                    <td className="py-4 px-3">
                      <div className="flex items-center gap-2">
                        <code className="text-green-400 bg-white/5 px-2 py-1 rounded text-xs truncate max-w-[120px]">
                          {transaction.sender}
                        </code>
                        <button
                          onClick={(e) => copyToClipboard(e, transaction.sender)}
                          className="p-2 text-text-muted hover:text-primary transition-colors"
                        >
                          <FaRegClipboard />
                        </button>
                      </div>
                    </td>
                    <td className="py-4 px-3">
                      <div className="flex items-center gap-2">
                        <code className="text-blue-400 bg-white/5 px-2 py-1 rounded text-xs truncate max-w-[120px]">
                          {transaction.receiver}
                        </code>
                        <button
                          onClick={(e) => copyToClipboard(e, transaction.receiver)}
                          className="p-2 text-text-muted hover:text-primary transition-colors"
                        >
                          <FaRegClipboard />
                        </button>
                      </div>
                    </td>
                    <td className="py-4 px-3">
                      <div className="flex items-center gap-2">
                        <code className="text-text-muted bg-white/5 px-2 py-1 rounded text-xs truncate max-w-[120px]">
                          {transaction.signature}
                        </code>
                        <button
                          onClick={(e) => copyToClipboard(e, transaction.signature)}
                          className="p-2 text-text-muted hover:text-primary transition-colors"
                        >
                          <FaRegClipboard />
                        </button>
                      </div>
                    </td>
                    <td className="py-4 px-3 text-text-muted text-sm">
                      {transaction.timestamp &&
                        transaction.timestamp.toDate &&
                        transaction.timestamp.toDate().toLocaleString()}
                    </td>
                    <td className="py-4 px-3 text-white font-medium">{transaction.amount}</td>
                    <td className="py-4 px-3">
                      {transaction.status !== "Added to block" ? (
                        <button
                          onClick={() => updateActionState(transaction)}
                          className={`px-4 py-2 rounded-lg font-medium text-sm transition-all ${
                            transaction.status === "Verify"
                              ? "bg-yellow-500/20 text-yellow-400 hover:bg-yellow-500/30"
                              : transaction.status === "Validate"
                                ? "bg-blue-500/20 text-blue-400 hover:bg-blue-500/30"
                                : transaction.status === "failed"
                                  ? "bg-red-500/20 text-red-500 hover:bg-red-500/30"
                                  : "bg-green-500/20 text-green-400 hover:bg-green-500/30"
                          }`}
                        >
                          {transaction.status}
                        </button>
                      ) : (
                        <span className="px-4 py-2 rounded-lg bg-green-500/20 text-green-400 text-sm font-medium">
                          {transaction.status}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={`glass-card p-12 text-center border ${teamBorder}`}>
            <p className="text-text-muted text-xl mb-6">
              There are no transactions present for Mining/Validation.
              <br />
              Please return to the Room.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/hackblocks" className="btn-primary flex items-center gap-2">
                My Blocks
              </Link>
              <Link
                to="/joinedhack"
                className="px-6 py-3 rounded-xl font-semibold text-white bg-white/10 hover:bg-white/20 transition-all flex items-center gap-2"
              >
                Go to Room Dashboard
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HackMemPool;
